export default __webpack_public_path__ + "static/media/qualys.3e58fdea.svg";